import script from "./QuotationTemplateDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotationTemplateDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuotationTemplateDetailPage.vue?vue&type=style&index=0&id=1248658b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1248658b"]])

export default __exports__